/* global axios */
import ApiClient from './ApiClient';

class AgentBotsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  deleteAgentBotAvatar(botId) {
    return axios.delete(`${this.url}/${botId}/avatar`);
  }

  resetAccessToken(botId) {
    return axios.post(`${this.url}/${botId}/reset_access_token`);
  }

  uploadKnowledge(botId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/${botId}/upload_knowledge`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  knowledgeOverview(botId) {
    return axios.get(`${this.url}/${botId}/knowledge_overview`);
  }

  knowledgeTest(botId, question, topK = 5) {
    return axios.post(`${this.url}/${botId}/knowledge_test`, {
      question,
      top_k: topK,
    });
  }

  deleteKnowledgeDocument(botId, documentId) {
    return axios.delete(`${this.url}/${botId}/delete_knowledge_document`, {
      params: { document_id: documentId },
    });
  }
}

export default new AgentBotsAPI();
